import { Modal, Typography, Button } from "antd";

const { Paragraph } = Typography;

// Окно подтверждения отправки заявки
const RequestModal = ({ data, visible, onCancel }) => {
  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      maskClosable={false}
      title="Заявка отправлена"
      width="300px"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Закрыть
        </Button>,
      ]}
    >
      <Paragraph
        style={{
          fontWeight: "700",
          fontSize: "12px",
        }}
      >
        {`Номер заявки: №${data}`}
      </Paragraph>
    </Modal>
  );
};

export default RequestModal;
